import Route from './Components/Route';
import Link from './Components/Link';
import * as utils from './utils';
import polyfill from './utils/hashChangePolyfill';
import * as actions from './actions';
import reducer from './reducer';
import Router from './Components/Router';

export { Route, Link, utils, polyfill, actions, reducer };
export default Router;
